<template>
  <div class="playground">
    <h3>Playground</h3>
    <div class="content">
      <div class="project-item">
        <p class="project-desc">Am working on putting up all my experiments and hacks.</p>
      </div>
    </div>
    <div id="playground-img">
    </div>
  </div>
</template>

<script>

  export default {
    name: 'playground',
  };
</script>

<style type="text/css">
  #playground-img {
    background-image: url('../../assets/playground.png');
    background-size: cover;
    width: auto;
    height: 400px;
    margin: -100px -50px 25px -50px;
  }
  @media screen and (max-width: 480px) {
    #playground-img {
      height: 200px;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// Playground.vue?a33adec6